/* Plúr Field — interactions: cart drawer, header, reveals, pinned process,
   parallax, live open status, custom cursor, product form. */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  const money = (cents) => {
    const fmt = (window.theme && window.theme.moneyFormat) || '€{{amount}}';
    const v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_with_comma_separator' ? v.replace('.', ',') : k === 'amount_no_decimals' ? Math.round(cents / 100) : v
    );
  };

  /* ---------- Header: solid after the hero, hides on scroll down ---------- */
  const header = $('[data-header]');
  const heroEl = $('[data-hero]');
  let lastY = scrollY;
  const updateHeader = () => {
    const y = scrollY;
    const heroEnd = heroEl ? heroEl.offsetTop + heroEl.offsetHeight - 80 : 40;
    const overHero = !!heroEl && y < heroEnd;
    if (header) {
      header.classList.toggle('is-solid', !overHero && y > 20);
      if (!document.body.classList.contains('menu-open')) header.classList.toggle('is-hidden', !overHero && y > 400 && y > lastY);
    }
    document.body.classList.toggle('on-hero', overHero && !!heroEl && heroEl.classList.contains('is-revealed'));
    lastY = y;
  };
  addEventListener('scroll', updateHeader, { passive: true });
  updateHeader();

  /* ---------- Full-screen menu ---------- */
  const toggle = $('[data-menu-toggle]');
  const menu = $('[data-menu]');
  if (toggle && menu) {
    const label = $('.menu-btn__label', toggle);
    // Keyboard: the closed menu is inert (unreachable); when open, focus moves in,
    // Tab cycles between the menu and its toggle, and closing returns focus to the toggle.
    const setMenu = (open) => {
      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open);
      menu.setAttribute('aria-hidden', !open);
      menu.inert = !open;
      document.body.classList.toggle('menu-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      if (label) label.textContent = open ? label.dataset.close : label.dataset.open;
      if (header) header.classList.remove('is-hidden');
      if (open) setTimeout(() => { const first = $('.site-menu__list a', menu); if (first) first.focus({ preventScroll: true }); }, 350);
      else if (wasOpen) toggle.focus({ preventScroll: true });
    };
    toggle.addEventListener('click', () => setMenu(toggle.getAttribute('aria-expanded') !== 'true'));
    addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setMenu(false);
      if (e.key !== 'Tab' || toggle.getAttribute('aria-expanded') !== 'true') return;
      const focusables = [toggle, ...$$('a, input, button', menu)].filter((el) => !el.disabled && el.offsetParent !== null);
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    $$('a', menu).forEach((a) => a.addEventListener('click', () => setMenu(false)));
  }

  /* ---------- Live open / closed status (Europe/Dublin) ---------- */
  const dublinNow = () => {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Dublin', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
    const get = (t) => parts.find((p) => p.type === t).value;
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(get('weekday'));
    return { day, minutes: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10) };
  };
  const toMin = (s) => {
    const [h, m] = String(s).split(':').map((n) => parseInt(n, 10) || 0);
    return h * 60 + m;
  };
  const fmt12 = (min) => {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return `${((h + 11) % 12) + 1}${m ? ':' + String(m).padStart(2, '0') : ''}${h < 12 ? 'am' : 'pm'}`;
  };
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const status = $('[data-open-status]');
  const now = dublinNow();
  if (status) {
    const days = status.dataset.openDays.split(',').map((d) => parseInt(d, 10));
    const from = toMin(status.dataset.openFrom);
    const to = toMin(status.dataset.openTo);
    const label = status.querySelector('span');
    const update = () => {
      const n = dublinNow();
      const open = days.includes(n.day) && n.minutes >= from && n.minutes < to;
      status.classList.toggle('is-open', open);
      if (open) {
        label.textContent = `Open · till ${fmt12(to)}`;
      } else {
        let next = null;
        for (let i = 0; i < 8 && next === null; i++) {
          const d = (n.day + i) % 7;
          if (days.includes(d) && (i > 0 || n.minutes < from)) next = i === 0 ? 'today' : i === 1 ? 'tomorrow' : DAYS[d];
        }
        label.textContent = next ? `Closed · opens ${next} ${fmt12(from)}` : 'Closed';
      }
    };
    update();
    setInterval(update, 60000);
  }
  $$('[data-hours] [data-day]').forEach((row) => row.classList.toggle('is-today', parseInt(row.dataset.day, 10) === now.day));

  /* ---------- Reveal on scroll ---------- */
  const splitIO = new IntersectionObserver(
    (entries) => entries.forEach((e) => e.isIntersecting && (e.target.classList.add('is-in'), splitIO.unobserve(e.target))),
    { rootMargin: '0px 0px 10% 0px' }
  );
  const revealIO = new IntersectionObserver(
    (entries) => entries.forEach((e) => e.isIntersecting && (e.target.classList.add('is-in'), revealIO.unobserve(e.target))),
    { rootMargin: '0px 0px 10% 0px' }
  );
  // Reduced motion: everything is shown at once (CSS also drops the animations).
  $$('[data-reveal]').forEach((el) => (reduceMotion ? el.classList.add('is-in') : revealIO.observe(el)));

  const stepIO = new IntersectionObserver((entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-in')), { threshold: 0.4 });
  $$('.process__step').forEach((el) => stepIO.observe(el));

  /* ---------- Scroll-linked: pinned process track + parallax ---------- */
  const processes = $$('[data-process]');
  const parallax = $$('[data-parallax] .cover, .roasting__hero img');
  const pinned = () => !reduceMotion && matchMedia('(min-width: 750px)').matches;

  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const vh = innerHeight;
    if (pinned()) {
      processes.forEach((sec) => {
        const track = $('[data-process-track]', sec);
        const bar = $('[data-process-bar]', sec);
        const r = sec.getBoundingClientRect();
        const total = sec.offsetHeight - vh;
        const p = Math.min(1, Math.max(0, -r.top / Math.max(1, total)));
        const max = track.scrollWidth - sec.clientWidth + 48;
        track.style.transform = `translate3d(${-p * Math.max(0, max)}px,0,0)`;
        if (bar) bar.style.setProperty('--p', p.toFixed(4));
      });
    }
    if (!reduceMotion) {
      parallax.forEach((img) => {
        const r = img.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = `translate3d(0, ${p * -8}%, 0) scale(1.12)`;
      });
    }
    const max = document.documentElement.scrollHeight - vh;
    document.documentElement.style.setProperty('--sp', max > 0 ? (scrollY / max).toFixed(4) : 0);
  };
  const requestTick = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onScroll);
    }
  };
  addEventListener('scroll', requestTick, { passive: true });
  addEventListener('resize', requestTick);
  onScroll();

  /* ---------- Card tilt ---------- */
  if (fine && !reduceMotion) {
    $$('[data-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = `perspective(900px) rotateY(${x * 5}deg) rotateX(${-y * 5}deg)`;
      });
      card.addEventListener('pointerleave', () => (card.style.transform = ''));
    });
  }

  /* ---------- Custom cursor ---------- */
  const cursor = $('.cursor');
  if (cursor && fine && !reduceMotion) {
    const label = $('.cursor__label', cursor);
    let x = innerWidth / 2;
    let y = innerHeight / 2;
    let cx = x;
    let cy = y;
    addEventListener('pointermove', (e) => {
      x = e.clientX;
      y = e.clientY;
      cursor.classList.add('is-ready');
      const target = e.target.closest('[data-cursor], a, button, summary, label');
      const text = target && target.dataset ? target.dataset.cursor : null;
      cursor.classList.toggle('is-label', !!text);
      cursor.classList.toggle('is-link', !!target && !text);
      if (text) label.textContent = text;
    });
    document.addEventListener('pointerleave', () => cursor.classList.remove('is-ready'));
    const loop = () => {
      cx += (x - cx) * 0.2;
      cy += (y - cy) * 0.2;
      cursor.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      requestAnimationFrame(loop);
    };
    loop();
  }


  /* ---------- Milling preloader (home, once per visit) ---------- */
  const loader = $('[data-loader]');
  const root = document.documentElement;
  if (loader && root.classList.contains('is-loading')) {
    const count = $('[data-loader-count]', loader);
    const start = performance.now();
    const dur = 1700;
    const step = (now) => {
      const p = Math.min(1, (now - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      count.textContent = String(Math.round(eased * 100)).padStart(3, '0');
      if (p < 1) return requestAnimationFrame(step);
      setTimeout(() => {
        loader.classList.add('is-done');
        root.classList.remove('is-loading');
        try { sessionStorage.setItem('plur-milled', '1'); } catch (e) {}
        setTimeout(() => loader.remove(), 1100);
      }, 250);
    };
    requestAnimationFrame(step);
  } else if (loader) {
    loader.remove();
  }

  /* ---------- Masked word / line reveals on headings ---------- */
  const splitTargets = $$('[data-split], [data-reveal] .display-2, [data-reveal] .display-1, .page-hero__title');
  splitTargets.forEach((el) => {
    if (el.classList.contains('is-split')) return;
    if (!el.querySelector('.line')) {
      if (el.children.length && !el.querySelector('.block')) return; // leave rich markup alone
      const lines = el.querySelectorAll('.block').length ? [...el.querySelectorAll('.block')] : [el];
      let w = 0;
      lines.forEach((line) => {
        const words = line.textContent.trim().split(/\s+/);
        line.innerHTML = words.map((word) => `<span class="split-word"><span style="--w:${w++}">${word.replace(/</g, '&lt;')}</span></span>`).join(' ');
      });
    } else {
      $$('.line > span', el).forEach((span, i) => span.style.setProperty('--w', i * 2));
    }
    el.classList.add('is-split');
    el.classList.remove('page-hero__title--anim');
    if (reduceMotion) el.classList.add('is-in');
    else splitIO.observe(el);
  });

  /* ---------- Stagger cards ---------- */
  $$('[data-reveal] .grid').forEach((grid) => $$('.card', grid).forEach((c, i) => c.style.setProperty('--i', i % 4)));

  /* ---------- Film dialogs ---------- */
  $$('[data-film-open]').forEach((b) =>
    b.addEventListener('click', () => {
      const d = document.getElementById(b.dataset.filmOpen);
      if (!d) return;
      d.showModal();
      const v = $('video', d);
      if (v) v.play().catch(() => {});
    })
  );
  $$('dialog.film').forEach((d) => {
    const close = () => {
      const v = $('video', d);
      if (v) v.pause();
      d.close();
    };
    $$('[data-film-close]', d).forEach((b) => b.addEventListener('click', close));
    d.addEventListener('click', (e) => e.target === d && close());
  });

  /* ---------- Product description: "Label\nValue" rows become a spec table ---------- */
  const DETAIL = ['producer', 'farm', 'washing station', 'region', 'variety', 'process', 'altitude', 'harvest', 'roast'];
  $$('[data-desc-details]').forEach((desc) => {
    const rows = [];
    $$('p, li', desc).forEach((p) => {
      const lines = p.innerText.split(/\n+/).map((l) => l.trim()).filter(Boolean);
      if (lines.length > 1 && DETAIL.includes(lines[0].replace(/:$/, '').toLowerCase())) {
        rows.push([lines[0].replace(/:$/, ''), lines.slice(1).join(' · ')]);
        p.remove();
      }
    });
    if (!rows.length) return;
    const dl = document.createElement('dl');
    dl.className = 'desc-details';
    rows.forEach(([k, v]) => {
      const div = document.createElement('div');
      const dt = document.createElement('dt');
      const dd = document.createElement('dd');
      dt.textContent = k;
      dd.textContent = v;
      div.append(dt, dd);
      dl.append(div);
    });
    desc.append(dl);
  });


  /* ---------- Chapter indicator ---------- */
  const chapters = $$('[data-chapter]').filter((el) => el.dataset.chapter && el.dataset.chapter.trim());
  if (chapters.length > 1 && document.body.dataset.chapters === 'true') {
    const ind = document.createElement('div');
    ind.className = 'chapter-ind';
    ind.setAttribute('aria-hidden', 'true');
    ind.innerHTML = '<span class="chapter-ind__ring"><span></span></span><span class="chapter-ind__name"></span>';
    document.body.append(ind);
    const ring = $('.chapter-ind__ring', ind);
    const num = $('.chapter-ind__ring span', ind);
    const name = $('.chapter-ind__name', ind);
    let current = -1;
    const update = () => {
      const mid = innerHeight * 0.5;
      let idx = -1;
      chapters.forEach((el, i) => {
        const r = el.getBoundingClientRect();
        if (r.top <= mid && r.bottom > mid) idx = i;
      });
      ind.classList.toggle('is-on', idx >= 0 && !document.body.classList.contains('menu-open'));
      if (idx < 0) return;
      const r = chapters[idx].getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (mid - r.top) / r.height));
      ring.style.setProperty('--deg', `${p * 360}deg`);
      if (idx !== current) {
        current = idx;
        num.textContent = String(idx + 1).padStart(2, '0');
        name.textContent = chapters[idx].dataset.chapter;
        name.classList.remove('is-swap');
        void name.offsetWidth;
        name.classList.add('is-swap');
      }
    };
    addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Page colour shifts with the chapter in view ---------- */
  const bgSections = $$('[data-bg]').filter((el) => ['ink', 'silin', 'clay'].includes(el.dataset.bg));
  if (bgSections.length && !reduceMotion) {
    document.body.classList.add('morph');
    const updateBg = () => {
      const mid = innerHeight * 0.55;
      let tone = '';
      bgSections.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top <= mid && r.bottom > mid * 0.4) tone = el.dataset.bg;
      });
      ['ink', 'silin', 'clay'].forEach((t) => document.body.classList.toggle(`bg-${t}`, t === tone));
    };
    addEventListener('scroll', updateBg, { passive: true });
    updateBg();
  }

  /* ---------- Manifesto: words light up as you read down ---------- */
  $$('[data-scrub]').forEach((el) => {
    const walk = (node) => {
      [...node.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) frag.append(part);
            else {
              const w = document.createElement('span');
              w.className = 'w';
              w.textContent = part;
              frag.append(w);
            }
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.classList.contains('chip')) {
          n.classList.add('w');
        }
      });
    };
    walk(el);
    const words = $$('.w', el);
    const update = () => {
      const r = el.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, (innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.35)));
      const lit = p * words.length * 1.15;
      words.forEach((w, i) => {
        const o = Math.min(1, Math.max(0.22, lit - i));
        w.style.setProperty('--o', o.toFixed(3));
        if (w.classList.contains('chip')) w.style.setProperty('--cs', o > 0.6 ? 1 : 0.4);
      });
    };
    if (reduceMotion) words.forEach((w) => { w.style.setProperty('--o', 1); w.style.setProperty('--cs', 1); });
    else { addEventListener('scroll', update, { passive: true }); update(); }
  });

  /* ---------- Ledger: product image follows the cursor ---------- */
  $$('[data-ledger]').forEach((ledger) => {
    const float = $('.ledger__float', ledger);
    const img = $('img', float);
    if (!float || !fine) return;
    let x = 0, y = 0, cx = 0, cy = 0, vx = 0, on = false, raf = 0;
    const loop = () => {
      const nx = cx + (x - cx) * 0.16;
      vx = nx - cx;
      cx = nx;
      cy += (y - cy) * 0.16;
      float.style.transform = `translate3d(${cx}px, ${cy}px, 0) translate(-50%, -50%) rotate(${Math.max(-12, Math.min(12, vx * 0.6))}deg) scale(${on ? 1 : 0.6})`;
      raf = on || Math.abs(vx) > 0.1 ? requestAnimationFrame(loop) : 0;
    };
    $$('[data-ledger-row]', ledger).forEach((row) => {
      row.addEventListener('pointerenter', (e) => {
        if (!row.dataset.img) return;
        img.src = row.dataset.img;
        if (!on) { cx = x = e.clientX; cy = y = e.clientY; }
        on = true;
        float.classList.add('is-on');
        if (!raf) raf = requestAnimationFrame(loop);
      });
      row.addEventListener('pointermove', (e) => { x = e.clientX; y = e.clientY; });
      row.addEventListener('pointerleave', () => { on = false; float.classList.remove('is-on'); });
    });
  });

  /* ---------- Mill: giant word drifts against the scroll ---------- */
  $$('[data-mill-giant]').forEach((g) => {
    const stage = g.parentElement;
    const update = () => {
      const r = stage.getBoundingClientRect();
      const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      g.style.setProperty('--gx', `${p * 18}vw`);
    };
    if (!reduceMotion) { addEventListener('scroll', update, { passive: true }); update(); }
  });


  /* ---------- Silín statement: texture drifts inside the letters ---------- */
  $$('[data-silin-statement]').forEach((sec) => {
    const word = $('.silin-statement__word', sec);
    if (reduceMotion || !word) return;
    const span = $('span', word);
    const update = () => {
      const r = sec.getBoundingClientRect();
      const p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
      word.style.setProperty('--ty', `${30 + p * 70}%`);
      span.style.setProperty('--wy', `${p * -6}vw`);
    };
    addEventListener('scroll', update, { passive: true });
    update();
  });

  /* ---------- Roast curve draws with the scroll ---------- */
  $$('[data-roast]').forEach((sec) => {
    const path = $('[data-roast-path]', sec);
    const dot = $('[data-roast-dot]', sec);
    const bands = $$('.roast__band', sec);
    const phases = $$('[data-phase]', sec);
    if (!path) return;
    const len = path.getTotalLength();
    path.style.strokeDasharray = len;
    const stops = [190, 420, 600]; // x where each phase ends
    const update = () => {
      const r = sec.getBoundingClientRect();
      const travel = Math.max(1, r.height - innerHeight);
      const p = reduceMotion || innerWidth < 990 ? 1 : Math.min(1, Math.max(0, -r.top / travel / 0.85));
      path.style.strokeDashoffset = len * (1 - p);
      const pt = path.getPointAtLength(len * p);
      dot.setAttribute('cx', pt.x);
      dot.setAttribute('cy', pt.y);
      const phase = stops.findIndex((x) => pt.x <= x);
      bands.forEach((b, i) => b.classList.toggle('is-on', i === phase));
      phases.forEach((li, i) => li.classList.toggle('is-on', i <= phase));
    };
    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
  });


  /* ---------- Perforated reveal: photos arrive through the dot print ---------- */
  const perfIO = new IntersectionObserver(
    (entries) => entries.forEach((e) => e.isIntersecting && (e.target.classList.add('is-perf'), perfIO.unobserve(e.target))),
    { rootMargin: '0px 0px -10% 0px' }
  );
  $$('[data-perf]').forEach((el) => perfIO.observe(el));

  /* ---------- Seed → Loaf: light each step's marker as it passes ---------- */
  $$('[data-process]').forEach((sec) => {
    const steps = $$('[data-step]', sec);
    const bgs = $$('[data-bg-step]', sec);
    let activeBg = -1;
    const update = () => {
      const mid = innerWidth * 0.62;
      const reading = innerWidth * 0.3;
      let current = 0;
      let best = Infinity;
      steps.forEach((st, i) => {
        const r = st.getBoundingClientRect();
        st.classList.toggle('is-on', r.left < mid);
        const d = Math.abs(r.left + r.width / 2 - reading);
        if (d < best) { best = d; current = i; }
      });
      if (bgs.length && current !== activeBg) {
        activeBg = current;
        bgs.forEach((bg) => bg.classList.toggle('is-active', +bg.dataset.bgStep === current));
      }
    };
    addEventListener('scroll', update, { passive: true });
    update();
  });


  /* ---------- Product page: slides, tasting notes, origin poster, buy bar ---------- */
  $$('[data-pdp]').forEach((pdp) => {
    const slides = $$('[data-slide]', pdp);
    const dots = $$('[data-go]', pdp);
    const show = (i) => {
      slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => { d.classList.toggle('is-active', n === i); d.setAttribute('aria-pressed', n === i); });
      const img = slides[i] && slides[i].matches('[data-perf]') ? slides[i] : null;
      if (img) img.classList.add('is-perf');
    };
    dots.forEach((d) => d.addEventListener('click', () => show(+d.dataset.go)));
    let sx = 0;
    const media = $('[data-pdp-media]', pdp);
    if (media && slides.length > 1) {
      media.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
      media.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) < 40) return;
        const cur = slides.findIndex((s) => s.classList.contains('is-active'));
        show((cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length);
      });
    }

    // Tasting notes: a short first line like "Blueberry · Tropical Fruit · Violet" becomes pills.
    const desc = $('[data-pdp-desc]', pdp);
    const notesEl = $('[data-pdp-notes]', pdp);
    if (desc && notesEl) {
      const first = desc.querySelector('p, h1, h2, h3, h4, h5, h6');
      const txt = first ? first.textContent.trim() : '';
      if (txt && txt.length < 70 && txt.includes('·')) {
        txt.split('·').map((t) => t.trim()).filter(Boolean).forEach((t) => {
          const li = document.createElement('li');
          li.textContent = t;
          notesEl.append(li);
        });
        notesEl.hidden = false;
        first.remove();
      }
    }

    // Origin poster: fill from the coffee's spec rows once they have been parsed.
    const poster = $('[data-pdp-poster]', pdp);
    if (poster && desc) {
      const rows = Object.fromEntries($$('.desc-details > div', desc).map((d) => [($('dt', d) || {}).textContent.trim().toLowerCase(), ($('dd', d) || {}).textContent.trim()]));
      const proc = rows.process ? rows.process.split(/[·,]/)[0].trim().split(' ')[0] : '';
      if (proc) $('[data-poster-process]', poster).textContent = proc.toUpperCase();
      if (rows.altitude) $('[data-poster-bl]', poster).textContent = rows.altitude;
      if (rows.variety) $('[data-poster-br]', poster).textContent = rows.variety;
      if (rows.region) $('[data-poster-lot]', poster).textContent = rows.region;
    }

    // Buy bar appears once the main add button has scrolled out of view.
    const bar = $('[data-pdp-bar]', pdp);
    const addBtn = $('[data-add-button]', pdp);
    const form = $('[data-product-form]', pdp);
    if (bar && addBtn && form) {
      new IntersectionObserver(([e]) => {
        const on = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', !on);
      }).observe(addBtn);
      const barAdd = $('[data-bar-add]', bar);
      barAdd.addEventListener('click', () => form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click());
      form.addEventListener('change', () => {
        setTimeout(() => {
          const price = $('[data-price]', pdp);
          if (price) $('[data-bar-price]', bar).textContent = price.firstChild.textContent.trim();
          barAdd.disabled = addBtn.disabled;
          barAdd.textContent = $('[data-add-label]', pdp).textContent;
        }, 0);
      });
    }
  });


  /* ---------- Halftone backdrops: photos printed in the Plúr dot screen ---------- */
  const halftone = (el) => {
    const src = el.dataset.halftone;
    if (!src) return;
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      el.append(canvas);
      const draw = () => {
        const w = el.clientWidth;
        const h = el.clientHeight;
        if (!w || !h) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(w * dpr);
        canvas.height = Math.round(h * dpr);
        const pitch = (parseFloat(el.dataset.halftonePitch) || (w < 750 ? 7 : 9)) * dpr;
        const cols = Math.ceil(canvas.width / pitch);
        const rows = Math.ceil(canvas.height / pitch);
        // sample the photo with object-fit: cover, one pixel per dot
        const sample = document.createElement('canvas');
        sample.width = cols;
        sample.height = rows;
        const sx = sample.getContext('2d', { willReadFrequently: true });
        const scale = Math.max(cols / img.naturalWidth, rows / img.naturalHeight);
        const dw = img.naturalWidth * scale;
        const dh = img.naturalHeight * scale;
        sx.drawImage(img, (cols - dw) / 2, (rows - dh) / 2, dw, dh);
        let data;
        try { data = sx.getImageData(0, 0, cols, rows).data; } catch (e) { canvas.remove(); return; }
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = `rgba(234, 228, 215, ${el.dataset.halftoneAlpha || 0.34})`;
        ctx.beginPath();
        for (let y = 0; y < rows; y++) {
          for (let x = 0; x < cols; x++) {
            const i = (y * cols + x) * 4;
            const lum = (data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114) / 255;
            const r = pitch * 0.5 * Math.pow(lum, 1.35);
            if (r < 0.35 * dpr) continue;
            const cx = x * pitch + pitch / 2;
            const cy = y * pitch + pitch / 2;
            ctx.moveTo(cx + r, cy);
            ctx.arc(cx, cy, r, 0, Math.PI * 2);
          }
        }
        ctx.fill();
        el.classList.add('is-dotted');
      };
      draw();
      let t;
      new ResizeObserver(() => { clearTimeout(t); t = setTimeout(draw, 150); }).observe(el);
    };
    img.src = src;
  };
  $$('[data-halftone]').forEach(halftone);


  /* ---------- The record is the player (Spotify iFrame API) ---------- */
  $$('[data-np]').forEach((np) => {
    const section = np.closest('[data-playlist]');
    const tracks = JSON.parse($('[data-np-tracks]', np).textContent || '[]').filter((t) => t.uri);
    if (!tracks.length) return;
    const titleEl = $('[data-np-title]', np);
    const artistEl = $('[data-np-artist]', np);
    const stateEl = $('[data-np-state]', np);
    const countEl = $('[data-np-count]', np);
    const embedEl = $('[data-np-embed]', np);
    const record = $('[data-np-record]', section);
    let idx = 0;
    let controller = null;
    let ready = false;
    let pendingPlay = false;
    let advancing = false;
    let paused = true;

    const showTrack = () => {
      const t = tracks[idx];
      titleEl.textContent = t.title;
      artistEl.textContent = t.artist || '';
      countEl.textContent = `${String(idx + 1).padStart(2, '0')} / ${String(tracks.length).padStart(2, '0')}`;
      record.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} ${t.title}${t.artist ? ' by ' + t.artist : ''}`);
    };
    const setProgress = (p) => section.style.setProperty('--np', Math.max(0, Math.min(1, p)).toFixed(4));
    const setState = (playing) => {
      paused = !playing;
      section.classList.toggle('is-playing', playing);
      section.classList.toggle('is-paused', !playing && section.classList.contains('has-started'));
      stateEl.textContent = playing ? 'Now playing' : section.classList.contains('has-started') ? 'Paused' : 'Press the record to play';
      $('[data-np-toggle]', np).setAttribute('aria-label', playing ? 'Pause' : 'Play');
      showTrack();
    };
    showTrack();

    const load = (i, autoplay) => {
      idx = (i + tracks.length) % tracks.length;
      showTrack();
      setProgress(0);
      if (!controller) return;
      controller.loadUri(tracks[idx].uri);
      if (autoplay) setTimeout(() => controller.play(), 350);
    };

    const boot = () => {
      if (window.__plurSpotify) return;
      window.__plurSpotify = true;
      window.onSpotifyIframeApiReady = (IFrameAPI) => {
        IFrameAPI.createController(embedEl, { uri: tracks[idx].uri, width: '100%', height: 80 }, (c) => {
          controller = c;
          ready = true; // the controller can take commands as soon as it exists
          c.addListener('ready', () => {
            if (pendingPlay) { pendingPlay = false; c.play(); }
          });
          if (pendingPlay) { pendingPlay = false; setTimeout(() => c.play(), 600); }
          c.addListener('playback_update', (e) => {
            const d = e.data || {};
            if (window.__npDebug) console.log('np', JSON.stringify(d));
            if (d.playingURI && d.playingURI !== tracks[idx].uri) {
              const found = tracks.findIndex((t) => t.uri === d.playingURI);
              if (found > -1) { idx = found; showTrack(); }
            }
            if (d.duration) setProgress(d.position / d.duration);
            if (!d.isPaused) section.classList.add('has-started');
            setState(!d.isPaused);
            if (!d.isPaused && d.duration && d.position >= d.duration - 400 && !advancing) {
              advancing = true;
              load(idx + 1, true);
              setTimeout(() => (advancing = false), 2000);
            }
          });
        });
      };
      const sc = document.createElement('script');
      sc.src = 'https://open.spotify.com/embed/iframe-api/v1';
      sc.async = true;
      document.body.append(sc);
    };
    // Load Spotify only when the section comes near, to keep the page light.
    new IntersectionObserver((entries, obs) => entries.forEach((e) => e.isIntersecting && (boot(), obs.disconnect())), { rootMargin: '400px' }).observe(section);

    const toggle = () => {
      section.classList.add('has-started');
      if (!controller || !ready) { pendingPlay = true; boot(); return; }
      if (paused) controller.play(); else controller.pause();
    };
    record.addEventListener('click', toggle);
    const sleeve = $('.sleeve', section);
    if (sleeve) { sleeve.style.cursor = 'pointer'; sleeve.addEventListener('click', toggle); }
    $('[data-np-toggle]', np).addEventListener('click', toggle);
    $('[data-np-next]', np).addEventListener('click', () => load(idx + 1, !paused || section.classList.contains('has-started')));
    $('[data-np-prev]', np).addEventListener('click', () => load(idx - 1, !paused || section.classList.contains('has-started')));
  });


  /* ---------- Videos further down the page load and play only when seen ---------- */
  const lazyVideos = $$('video[data-lazy-play]');
  if (lazyVideos.length) {
    const vio = new IntersectionObserver((entries) => entries.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); } if (!reduceMotion && !v.dataset.userPaused) v.play().catch(() => {}); }
      else v.pause();
    }), { rootMargin: '200px 0px' });
    lazyVideos.forEach((v) => vio.observe(v));
  }


  /* ---------- Brew bags: the steps follow the film ---------- */
  $$('[data-brew-ritual]').forEach((fig) => {
    const v = fig.querySelector('video');
    const steps = $$('[data-t]', fig);
    const times = steps.map((s) => parseFloat(s.dataset.t));
    const loop = parseFloat(fig.dataset.loop) || 10.7;
    const btn = fig.querySelector('[data-brew-toggle]');
    let raf = 0;
    const tick = () => {
      const t = v.currentTime;
      let k = 0;
      times.forEach((x, i) => { if (t >= x) k = i; });
      const end = k < times.length - 1 ? times[k + 1] : loop;
      steps.forEach((s, i) => {
        s.classList.toggle('is-on', i === k);
        s.style.setProperty('--p', i < k ? 1 : i === k ? Math.min(1, (t - times[k]) / (end - times[k])) : 0);
      });
      raf = v.paused ? 0 : requestAnimationFrame(tick);
    };
    const label = () => {
      const playing = !v.paused;
      btn.setAttribute('aria-label', playing ? 'Pause the brewing video' : 'Play the brewing video');
      btn.setAttribute('aria-pressed', playing ? 'false' : 'true');
      fig.classList.toggle('is-playing', playing);
    };
    v.addEventListener('play', () => { cancelAnimationFrame(raf); tick(); label(); });
    v.addEventListener('pause', () => { cancelAnimationFrame(raf); raf = 0; label(); });
    v.addEventListener('seeked', () => { if (v.paused) tick(); });
    btn.addEventListener('click', () => {
      if (v.paused) { delete v.dataset.userPaused; if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); } v.play().catch(() => {}); }
      else { v.dataset.userPaused = '1'; v.pause(); }
    });
    if (reduceMotion) fig.classList.add('is-static');
    label();
  });

  /* ---------- Collection view toggle (list / photos), remembered per visitor ---------- */
  $$('[data-collection-view]').forEach((wrap) => {
    let saved = null;
    try { saved = localStorage.getItem('plur-collection-view'); } catch (e) {}
    const set = (v) => {
      wrap.dataset.collectionView = v;
      $$('[data-view]', wrap).forEach((b) => b.setAttribute('aria-pressed', b.dataset.view === v));
    };
    if (saved === 'list' || saved === 'grid') set(saved);
    $$('[data-view]', wrap).forEach((b) => b.addEventListener('click', () => {
      set(b.dataset.view);
      try { localStorage.setItem('plur-collection-view', b.dataset.view); } catch (e) {}
    }));
  });

  /* ---------- Stockist map loads only when asked ---------- */
  $$('[data-map-facade]').forEach((frame) => {
    const btn = $('[data-map-load]', frame);
    if (!btn) return;
    btn.addEventListener('click', () => {
      const f = document.createElement('iframe');
      f.src = frame.dataset.src;
      f.title = frame.dataset.title || 'Map';
      f.loading = 'lazy';
      f.allowFullscreen = true;
      f.referrerPolicy = 'no-referrer-when-downgrade';
      frame.append(f);
      frame.classList.add('is-loaded');
      f.focus();
    });
  });

  /* ---------- Cart ---------- */
  const drawer = $('#CartDrawer');
  const routes = (window.theme && window.theme.routes) || { root: '/' };

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $('.drawer__panel', drawer).focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  $$('[data-drawer-close]').forEach((el) => el.addEventListener('click', closeDrawer));
  addEventListener('keydown', (e) => e.key === 'Escape' && closeDrawer());
  $$('[data-cart-open]').forEach((el) =>
    el.addEventListener('click', (e) => {
      if (!drawer || document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      openDrawer();
    })
  );

  // Re-render cart items using Shopify's Section Rendering API against the cart drawer snippet's section.
  const refreshCart = async () => {
    const [cart, html] = await Promise.all([
      fetch(`${routes.root}cart.js`).then((r) => r.json()),
      fetch(`${routes.root}?section_id=cart-items`).then((r) => (r.ok ? r.text() : '')),
    ]);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-items-source]');
    $$('[data-cart-items]').forEach((el) => fresh && (el.innerHTML = fresh.innerHTML));
    $$('[data-cart-total]').forEach((el) => (el.textContent = money(cart.total_price)));
    $$('[data-cart-count]').forEach((el) => (el.textContent = `(${cart.item_count})`));
    $$('[data-cart-count-badge]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0 && !el.classList.contains('text-btn__count');
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
    return cart;
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || !drawer) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(`${routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        alert(err.description || 'Could not add to basket.');
        return;
      }
      await refreshCart();
      openDrawer();
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-qty-change]');
    if (!b) return;
    const line = b.closest('[data-key]');
    const body = b.closest('[data-cart-items]');
    if (body) body.classList.add('is-loading');
    await fetch(`${routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.dataset.key, quantity: parseInt(b.dataset.qtyChange, 10) }),
    });
    await refreshCart();
    if (body) body.classList.remove('is-loading');
  });

  /* ---------- Product form: quantity steppers + variant matching ---------- */
  $$('[data-qty-input]').forEach((wrap) => {
    const input = $('input', wrap);
    $$('[data-step]', wrap).forEach((b) =>
      b.addEventListener('click', () => {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
      })
    );
  });

  $$('[data-product-form]').forEach((form) => {
    const json = $('[data-variants]', form);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const priceEl = form.closest('[data-product]').querySelector('[data-price]');
    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option]')) return;
      const selected = $$('fieldset', form).map((fs) => ($('input:checked', fs) || {}).value);
      const v = variants.find((x) => x.options.every((o, i) => o === selected[i]));
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to basket' : 'Sold out';
      if (priceEl) priceEl.firstChild.textContent = money(v.price);
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
      if (v.featured_media) {
        const fig = document.querySelector(`[data-media-id="${v.featured_media.id}"]`);
        if (fig) fig.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  });

  /* ---------- 3D product models (Shopify model-viewer) ---------- */
  if ($('[data-model]') && window.Shopify && Shopify.loadFeatures) {
    Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {} }]);
  }
})();
